export default __webpack_public_path__ + "static/media/upgreenrow.f35e47fe.svg";